import { createParser, useQueryState } from 'nuqs'
import { z } from 'zod'

const PracticeRequestNavigationSourceSchema = z.discriminatedUnion('source', [
  z.object({ source: z.literal('list') }),
  z.object({ source: z.literal('requests') }),
])

export type PracticeRequestNavigationSource = z.infer<
  typeof PracticeRequestNavigationSourceSchema
>

function serializeSourceValue(value: PracticeRequestNavigationSource): string {
  return value.source
}

const parseAsPracticeRequestNavigationSource =
  createParser<PracticeRequestNavigationSource>({
    parse(queryValue) {
      return (
        PracticeRequestNavigationSourceSchema.safeParse({
          source: queryValue,
        }).data ?? null
      )
    },
    serialize: serializeSourceValue,
  }).withDefault({ source: 'list' })

export function serializePracticeRequestNavigationSource(
  baseUrl: string,
  navigationSource: PracticeRequestNavigationSource,
): string {
  const questionMarkIndex = baseUrl.indexOf('?')
  const path =
    questionMarkIndex >= 0 ? baseUrl.slice(0, questionMarkIndex) : baseUrl
  const params = new URLSearchParams(
    questionMarkIndex >= 0 ? baseUrl.slice(questionMarkIndex + 1) : '',
  )

  if (navigationSource.source === 'list') {
    params.delete('source')
  } else {
    params.set('source', serializeSourceValue(navigationSource))
  }

  const search = params.toString()
  return search.length > 0 ? `${path}?${search}` : path
}

export function usePracticeRequestNavigationSource() {
  const [source] = useQueryState(
    'source',
    parseAsPracticeRequestNavigationSource,
  )
  return source
}
